export type QuestionnaireVersion = 'historical' | 'current';

const QUESTIONNAIRE_CHANGE_YEAR = 2026;
const QUESTIONNAIRE_CHANGE_MONTH = 1;

export const getQuestionnaireVersion = (period?: string | null): QuestionnaireVersion => {
  const match = /^(\d{4})-(\d{2})$/.exec(period || '');

  if (!match) return 'current';

  const year = Number(match[1]);
  const month = Number(match[2]);
  const isHistorical =
    year < QUESTIONNAIRE_CHANGE_YEAR ||
    (year === QUESTIONNAIRE_CHANGE_YEAR && month < QUESTIONNAIRE_CHANGE_MONTH);

  return isHistorical ? 'historical' : 'current';
};

export const resolveQuestionText = (
  version: QuestionnaireVersion,
  questionId: number,
  sourceText: string,
  translate: (key: string, options: { defaultValue: string }) => string,
): string => {
  if (version === 'historical') return sourceText;

  return translate(`items.${questionId}`, { defaultValue: sourceText });
};
